import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ProductCard } from "./ProductCard";

const Brand = () => (
  <>
    LEAP<span className="text-bronze">BODIES</span>
  </>
);

export const ProductPage = ({
  testId,
  title,
  intro,
  variants,
  scratchbook,
  children,
}) => (
  <div data-testid={`${testId}-page`} className="min-h-screen flex flex-col">
    <header className="border-b border-ink/10 px-6 py-4 bg-[#F9F8F5]/90 backdrop-blur-md">
      <div className="max-w-5xl mx-auto flex items-center justify-between">
        <Link
          to="/leapbodies"
          data-testid={`${testId}-back-link`}
          className="inline-flex items-center gap-2 text-sm text-mutedink hover:text-oxblood transition-colors duration-300"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to LeapBodies
        </Link>
        <span className="font-cinzel text-xs sm:text-sm tracking-[0.25em] text-ink">
          <Brand />
        </span>
      </div>
    </header>

    <main className="flex-1 px-6 py-16 sm:py-20">
      <div className="max-w-5xl mx-auto">
        <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-mutedink mb-4">
          LeapBodies — Product
        </p>
        <h1 className="font-serif font-light tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl">
          {title}
        </h1>
        <p className="mt-6 max-w-xl text-base font-light text-[#2A2A2A] leading-relaxed">
          {intro}
        </p>

        <div
          className="mt-12 grid sm:grid-cols-2 gap-6"
          data-testid={`${testId}-variants`}
        >
          {variants.map((v) => (
            <ProductCard key={v.id} testId={testId} v={v} />
          ))}
        </div>

        {children}

        {scratchbook && (
          <section
            data-testid="scratchbook-section"
            className="mt-24 border-t border-ink/10 pt-14"
          >
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-mutedink mb-3">
              The Scratch Book
            </p>
            <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-ink mb-3">
              {scratchbook.heading}
            </h2>
            <p className="max-w-xl text-sm text-mutedink leading-relaxed mb-12">
              {scratchbook.subheading}
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
              {scratchbook.pages.map((page, i) => (
                <figure
                  key={page.src}
                  data-testid={`scratch-photo-${i + 1}`}
                  className={`relative bg-white border border-ink/10 p-3 pb-12 shadow-sm ${page.rotate}`}
                >
                  <span
                    aria-hidden="true"
                    className="absolute -top-3 left-1/2 -translate-x-1/2 w-20 h-6 bg-linen/90 border border-ink/5 -rotate-3"
                  />
                  <img
                    src={page.src}
                    alt={`Scratch book — ${page.caption}`}
                    loading="lazy"
                    className="w-full aspect-[4/3] object-cover"
                  />
                  <figcaption className="absolute bottom-3 inset-x-0 text-center font-mono text-[11px] tracking-[0.15em] uppercase text-mutedink">
                    {page.caption}
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>
        )}
      </div>
    </main>

    <footer className="bg-[#111111] text-[#F9F8F5] px-6 py-8">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="font-cinzel text-sm tracking-[0.2em]">
          <Brand />
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#F9F8F5]/40">
          © Hailey and Chloe Holdings Inc.
        </p>
      </div>
    </footer>
  </div>
);
